import { useEffect } from "react";
import { Icon } from "../components/Icon";

export interface ToastMessage { message: string; tone: "good" | "critical" }

/**
 * A word about what just happened, floating at the corner of the screen: it
 * takes no room in the page, so answering something never moves what is around
 * it. A good one goes by itself; a failure stays until it is read.
 */
export function Toast({ toast, onDismiss }: { toast: ToastMessage | null; onDismiss: () => void }) {
  useEffect(() => {
    if (toast?.tone !== "good") return;
    const timer = window.setTimeout(onDismiss, 4000);
    return () => window.clearTimeout(timer);
  }, [toast, onDismiss]);
  if (!toast) return null;
  return <div className={`toast toast-${toast.tone}`} role={toast.tone === "critical" ? "alert" : "status"} data-state={toast.tone === "good" ? "done" : "failed"}>
    <Icon name={toast.tone === "good" ? "done" : "alert"} size={18} />
    <span className="toast-text">{toast.message}</span>
    <button type="button" className="btn btn-quiet" onClick={onDismiss}>知道了</button>
  </div>;
}
